/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * PNRタイプ
 */
export interface GetOrderResponseDataOrderType {
  /**
   * 社員用PNR区分<br/> フリーテキストがSTFであるOSIが存在するか、PTCがASBである搭乗者が存在する場合にtrue
   */
  isStaffBooking?: boolean;
  /**
   * 特典PNR区分<br/> SSR FQTRが存在し、かつPNR作成オフィスIDの4-5桁目がNHである場合にtrue
   */
  isAwardBooking?: boolean;
  /**
   * PNRチャネル区分<br/> nh：直営PNR(PNRオーナーオフィスIDの4-6桁目がNH0である)<br/> ndc：NDC PNR(PNRオーナーオフィスIDがNDCオフィスマスタに存在する)<br/> gds：GDS PNR(PNRオーナーオフィスIDの4-5桁目がNHでなく、かつNDC PNRでない)<br/>
   */
  channelType: GetOrderResponseDataOrderType.ChannelTypeEnum;
  /**
   * PNRチャネル詳細区分<br/> asw：ASW作成PNR(PNRオーナーオフィスIDがオフィスマスタに存在する)<br/> callCenter：コールセンター作成PNR(PNRオーナーオフィスIDがオフィスマスタに存在せず、かつ4-6桁目がNH0である)<br/> merchantAnaNdc：マーチャントがANAのNDC PNR(PNRオーナーオフィスIDがNDCオフィスマスタに存在し、かつマーチャント識別が1)<br/> merchantNotAnaNdc：マーチャントがANA以外のNDC PNR(PNRオーナーオフィスIDがNDCオフィスマスタに存在し、かつマーチャント識別が2)<br/> ※PNRチャネル区分がnhまたはndcである場合にのみ設定される
   */
  channelDetail?: GetOrderResponseDataOrderType.ChannelDetailEnum;
  /**
   * グループPNR区分<br/> DxAPIよりグループPNR識別が返却されている場合にtrue
   */
  isGroupBooking?: boolean;
  /**
   * 海外ツアーPNR区分<br/> PNRオーナーオフィスコードが、設定ファイルに定義される海外ツアーオフィスコードパターンと前方一致する場合にtrue
   */
  isInternationalTourBooking?: boolean;
  /**
   * INFINI PNR区分<br/> PNRオーナーオフィスコードが、設定ファイルに定義されるINFINI PNRオフィスコードリストに含まれる場合にtrue
   */
  isInfiniBooking?: boolean;
  /**
   * INFINIツアーPNR区分<br/> INFINI PNR区分がtrueであり、かつフリーテキストが\"HANT\"で始まるOSIエレメントが存在する場合true
   */
  isInfiniTourBooking?: boolean;
}
export namespace GetOrderResponseDataOrderType {
  export type ChannelTypeEnum = 'nh' | 'ndc' | 'gds' | 'nh3';
  export const ChannelTypeEnum = {
    Nh: 'nh' as ChannelTypeEnum,
    Ndc: 'ndc' as ChannelTypeEnum,
    Gds: 'gds' as ChannelTypeEnum,
    Nh3: 'nh3' as ChannelTypeEnum,
  };
  export type ChannelDetailEnum = 'asw' | 'callCenter' | 'merchantAnaNdc' | 'merchantNotAnaNdc';
  export const ChannelDetailEnum = {
    Asw: 'asw' as ChannelDetailEnum,
    CallCenter: 'callCenter' as ChannelDetailEnum,
    MerchantAnaNdc: 'merchantAnaNdc' as ChannelDetailEnum,
    MerchantNotAnaNdc: 'merchantNotAnaNdc' as ChannelDetailEnum,
  };
}
